import { createAction, createReducer } from '@reduxjs/toolkit';
import { types } from '../types';

const translationCache = createAction(types.GET_TRANSLATION_CACHE_SUCCESS);
const currentLanguage = createAction(types.GET_TRANSLATION_CACHE);

const initialState = {
  translationCache: {},
  currentLanguage:""
};

const TranslationReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(translationCache, (state, action) => {
      state.translationCache = action.response;
    })
    .addCase(currentLanguage,(state,action)=>{
      state.currentLanguage = action.language || 'English';
    })
    .addDefaultCase(() => { });
});

export default TranslationReducer;